import React, { useEffect, useMemo, useState, useCallback } from 'react'
import { withRouter, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import api, { apiAction, apiActionWithRoute } from '../../../api'

import { queryParams, objectToSearch } from '../../../common/utils'
import { FloatingButton, Table, ConfirmModal, Loading } from  '../../../components'
import S from './styled'
import actions from './actions'

import columns from './columns'

const IngredientsList = props => {

  const {
    fetchFoodKinds,
    fetchIngredients,
    history,
    foodKinds,
    ingredients,
    isLoading,
    pagination,
  } = props

  const search = useLocation().search
  const query = new URLSearchParams(search)
  const sortBy = query.get('sortBy')
  const sortType = query.get('sortType')

  useEffect(() => {
    (async () => {
      await fetchFoodKinds()
      await fetchIngredients(search)
    })()
  }, [search]) //eslint-disable-line react-hooks/exhaustive-deps

  const [itemToDelete, setShowDeleteModal] = useState(null)

  const { onEdit, onDelete, handleDelete } = actions({ ...props, setShowDeleteModal })

  const tableColumns = useMemo(() => {
    return columns({ foodKinds, onEdit, handleDelete })
  }, [foodKinds, onEdit, handleDelete])

  const handleAdd = useCallback(() => {
    history.push('/ingredients/new')
  }, [history])


  const onSort = useCallback(({ sortBy, sortType }) => {
    history.push(`${history.location.pathname}?sortBy=${sortBy}&sortType=${sortType}`)
  }, [history])

  const hadleChangePage = useCallback(({ selected }) => {
    if (selected !== pagination.page) {
      const result = queryParams(search)
      result.page = selected
      history.push(`${history.location.pathname}?${objectToSearch(result)}`)
    }
  }, [history, search, pagination])

  return (
    <React.Fragment>
      <Table
        columns={tableColumns}
        rows={ingredients}
        sortBy={sortBy}
        sortType={sortType}
        onSort={onSort}
        fillContainer
        pagination={pagination}
        onPageChange={hadleChangePage}
      />
      <FloatingButton onClick={handleAdd}>
        <S.PlusSign>+</S.PlusSign>
      </FloatingButton>
      {
        !!itemToDelete && (
          <ConfirmModal
            isOpened
            onClose={() => setShowDeleteModal(null)}
            onConfirm={() => {
              onDelete(itemToDelete)
              setShowDeleteModal(null)
            }}
            redConfirm
          >
              Are you sure you want to delete this item?
          </ConfirmModal>
        )
      }
      {isLoading && <Loading overlay/>}
    </React.Fragment>
  )
}

const mapStateToProps = (state, { entityName }) => ({
  foodKinds: state.foodKinds.list,
  locales: state.locales.list,
  ingredients: state.ingredients.list,
  isLoading: state.ingredients.isLoading,
  pagination: state.ingredients.pagination,
})

const mapDispatchToProps = (dispatch, { entityName } ) => ({
  fetchFoodKinds: () => dispatch(apiAction(api.getFoodKinds)()),
  fetchRegions: () => dispatch(apiAction(api.getRegions)()),
  fetchIngredients: search => dispatch(apiAction(api.getIngredientHeaders)(queryParams(search))),
  deleteIngredient: entityId => dispatch(apiActionWithRoute(api.deleteIngredient)(entityId)()),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IngredientsList))
